<a (click)="toggleFollowing()" ngbTooltip="{{ 'Follow train on the map' | translate }}">
    <fa-icon [icon]="(isFollowing$ | async) ? 'location-slash' : 'location'"></fa-icon>
</a>
